// Generated from live Printful product detail responses. No invented variants.
// Catalog verification is NOT mockup verification or authorization to fulfill orders.
export const POD_EXPANSION = [
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-unisex-v-neck-tee-223",
    "name": "SCORPION UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-unisex-v-neck-tee-223",
    "name": "SNAKE UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-unisex-v-neck-tee-223",
    "name": "JELLYFISH UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-unisex-v-neck-tee-223",
    "name": "PUFFER UNISEX V-NECK TEE",
    "productId": 223,
    "productName": "Unisex V-Neck Tee | Bella + Canvas 3005",
    "variantId": 8025,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-unisex-long-sleeve-tee-356",
    "name": "SCORPION UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-unisex-long-sleeve-tee-356",
    "name": "SNAKE UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-unisex-long-sleeve-tee-356",
    "name": "JELLYFISH UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-unisex-long-sleeve-tee-356",
    "name": "PUFFER UNISEX LONG SLEEVE TEE",
    "productId": 356,
    "productName": "Unisex Long Sleeve Tee | Bella + Canvas 3501",
    "variantId": 10143,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-men-s-premium-heavyweight-tee-508",
    "name": "SCORPION MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-men-s-premium-heavyweight-tee-508",
    "name": "SNAKE MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-men-s-premium-heavyweight-tee-508",
    "name": "JELLYFISH MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-men-s-premium-heavyweight-tee-508",
    "name": "PUFFER MEN'S PREMIUM HEAVYWEIGHT TEE",
    "productId": 508,
    "productName": "Men's Premium Heavyweight Tee | Cotton Heritage MC1086",
    "variantId": 12762,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-women-s-relaxed-t-shirt-360",
    "name": "SCORPION WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-women-s-relaxed-t-shirt-360",
    "name": "SNAKE WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-women-s-relaxed-t-shirt-360",
    "name": "JELLYFISH WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-women-s-relaxed-t-shirt-360",
    "name": "PUFFER WOMEN'S RELAXED T-SHIRT",
    "productId": 360,
    "productName": "Women's Relaxed T-Shirt | Bella + Canvas 6400",
    "variantId": 10253,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-unisex-premium-sweatshirt-411",
    "name": "SCORPION UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-unisex-premium-sweatshirt-411",
    "name": "SNAKE UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-unisex-premium-sweatshirt-411",
    "name": "JELLYFISH UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-unisex-premium-sweatshirt-411",
    "name": "PUFFER UNISEX PREMIUM SWEATSHIRT",
    "productId": 411,
    "productName": "Unisex Premium Sweatshirt | Cotton Heritage M2480",
    "variantId": 11250,
    "color": "White",
    "size": "M",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-eco-tote-bag-367",
    "name": "SCORPION ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-eco-tote-bag-367",
    "name": "SNAKE ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-eco-tote-bag-367",
    "name": "JELLYFISH ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-eco-tote-bag-367",
    "name": "PUFFER ECO TOTE BAG",
    "productId": 367,
    "productName": "Eco Tote Bag | Econscious EC8000",
    "variantId": 10457,
    "color": "Black",
    "size": "One size",
    "technique": "DTG",
    "placement": "front",
    "view": "front",
    "layout": "left_chest",
    "productType": "tee",
    "catalogGroup": "APPAREL",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-white-ceramic-mug-with-color-inside-403",
    "name": "SCORPION WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-white-ceramic-mug-with-color-inside-403",
    "name": "SNAKE WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-white-ceramic-mug-with-color-inside-403",
    "name": "JELLYFISH WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-white-ceramic-mug-with-color-inside-403",
    "name": "PUFFER WHITE CERAMIC MUG WITH COLOR INSIDE",
    "productId": 403,
    "productName": "White Ceramic Mug with Color Inside",
    "variantId": 11051,
    "color": "Black",
    "size": "11 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-enamel-mug-407",
    "name": "SCORPION ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-enamel-mug-407",
    "name": "SNAKE ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-enamel-mug-407",
    "name": "JELLYFISH ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-enamel-mug-407",
    "name": "PUFFER ENAMEL MUG",
    "productId": 407,
    "productName": "Enamel Mug",
    "variantId": 11189,
    "color": "White",
    "size": "12 oz",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "mug",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-insulated-tumbler-with-a-straw-742",
    "name": "SCORPION INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-insulated-tumbler-with-a-straw-742",
    "name": "SNAKE INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-insulated-tumbler-with-a-straw-742",
    "name": "JELLYFISH INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-insulated-tumbler-with-a-straw-742",
    "name": "PUFFER INSULATED TUMBLER WITH A STRAW",
    "productId": 742,
    "productName": "Insulated Tumbler with a Straw",
    "variantId": 19111,
    "color": "White",
    "size": "20 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-stainless-steel-water-bottle-382",
    "name": "SCORPION STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-stainless-steel-water-bottle-382",
    "name": "SNAKE STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-stainless-steel-water-bottle-382",
    "name": "JELLYFISH STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-stainless-steel-water-bottle-382",
    "name": "PUFFER STAINLESS STEEL WATER BOTTLE",
    "productId": 382,
    "productName": "Stainless Steel Water Bottle",
    "variantId": 10798,
    "color": "White",
    "size": "17 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-wine-tumbler-632",
    "name": "SCORPION WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-wine-tumbler-632",
    "name": "SNAKE WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-wine-tumbler-632",
    "name": "JELLYFISH WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-wine-tumbler-632",
    "name": "PUFFER WINE TUMBLER",
    "productId": 632,
    "productName": "Wine Tumbler",
    "variantId": 16046,
    "color": "White",
    "size": "12 oz",
    "technique": "UV",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "tumbler",
    "catalogGroup": "DRINKWARE",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-cork-back-coaster-611",
    "name": "SCORPION CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-cork-back-coaster-611",
    "name": "SNAKE CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-cork-back-coaster-611",
    "name": "JELLYFISH CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-cork-back-coaster-611",
    "name": "PUFFER CORK-BACK COASTER",
    "productId": 611,
    "productName": "Cork-Back Coaster",
    "variantId": 15662,
    "color": "",
    "size": "3.74″×3.74″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-gaming-mouse-pad-583",
    "name": "SCORPION GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-gaming-mouse-pad-583",
    "name": "SNAKE GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-gaming-mouse-pad-583",
    "name": "JELLYFISH GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-gaming-mouse-pad-583",
    "name": "PUFFER GAMING MOUSE PAD",
    "productId": 583,
    "productName": "Gaming Mouse Pad",
    "variantId": 14942,
    "color": "White",
    "size": "36″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-desk-mat-853",
    "name": "SCORPION DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-desk-mat-853",
    "name": "SNAKE DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-desk-mat-853",
    "name": "JELLYFISH DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-desk-mat-853",
    "name": "PUFFER DESK MAT",
    "productId": 853,
    "productName": "Desk Mat",
    "variantId": 22325,
    "color": "Black",
    "size": "12″×18″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-laptop-sleeve-394",
    "name": "SCORPION LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-laptop-sleeve-394",
    "name": "SNAKE LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-laptop-sleeve-394",
    "name": "JELLYFISH LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-laptop-sleeve-394",
    "name": "PUFFER LAPTOP SLEEVE",
    "productId": 394,
    "productName": "Laptop Sleeve",
    "variantId": 10984,
    "color": "",
    "size": "13″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-throw-blanket-395",
    "name": "SCORPION THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-throw-blanket-395",
    "name": "SNAKE THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-throw-blanket-395",
    "name": "JELLYFISH THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-throw-blanket-395",
    "name": "PUFFER THROW BLANKET",
    "productId": 395,
    "productName": "Throw Blanket",
    "variantId": 10986,
    "color": "",
    "size": "50″×60″",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-ruled-line-spiral-notebook-946",
    "name": "SCORPION RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-ruled-line-spiral-notebook-946",
    "name": "SNAKE RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-ruled-line-spiral-notebook-946",
    "name": "JELLYFISH RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-ruled-line-spiral-notebook-946",
    "name": "PUFFER RULED LINE SPIRAL NOTEBOOK",
    "productId": 946,
    "productName": "Ruled Line Spiral Notebook",
    "variantId": 24305,
    "color": "",
    "size": "One size",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-enhanced-matte-paper-poster-in-1",
    "name": "SCORPION ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-enhanced-matte-paper-poster-in-1",
    "name": "SNAKE ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-enhanced-matte-paper-poster-in-1",
    "name": "JELLYFISH ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-enhanced-matte-paper-poster-in-1",
    "name": "PUFFER ENHANCED MATTE PAPER POSTER (IN)",
    "productId": 1,
    "productName": "Enhanced Matte Paper Poster (in)",
    "variantId": 1,
    "color": "",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-enhanced-matte-paper-framed-poster-in-2",
    "name": "SCORPION ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-enhanced-matte-paper-framed-poster-in-2",
    "name": "SNAKE ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-enhanced-matte-paper-framed-poster-in-2",
    "name": "JELLYFISH ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-enhanced-matte-paper-framed-poster-in-2",
    "name": "PUFFER ENHANCED MATTE PAPER FRAMED POSTER (IN)",
    "productId": 2,
    "productName": "Enhanced Matte Paper Framed Poster (in)",
    "variantId": 10749,
    "color": "White",
    "size": "18″×24″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-magsafe-tough-case-for-iphone-798",
    "name": "SCORPION MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-magsafe-tough-case-for-iphone-798",
    "name": "SNAKE MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-magsafe-tough-case-for-iphone-798",
    "name": "JELLYFISH MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-magsafe-tough-case-for-iphone-798",
    "name": "PUFFER MAGSAFE TOUGH CASE FOR IPHONE®",
    "productId": 798,
    "productName": "MagSafe Tough Case for iPhone®",
    "variantId": 20318,
    "color": "Matte",
    "size": "iPhone 15",
    "technique": "SUBLIMATION",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-greeting-card-568",
    "name": "SCORPION GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-greeting-card-568",
    "name": "SNAKE GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-greeting-card-568",
    "name": "JELLYFISH GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-greeting-card-568",
    "name": "PUFFER GREETING CARD",
    "productId": 568,
    "productName": "Greeting Card",
    "variantId": 14457,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "front",
    "view": "front",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-standard-postcard-433",
    "name": "SCORPION STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-standard-postcard-433",
    "name": "SNAKE STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-standard-postcard-433",
    "name": "JELLYFISH STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-standard-postcard-433",
    "name": "PUFFER STANDARD POSTCARD",
    "productId": 433,
    "productName": "Standard Postcard",
    "variantId": 11513,
    "color": "",
    "size": "4″×6″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-kiss-cut-stickers-358",
    "name": "SCORPION KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "snake",
    "file": "snake.png",
    "slug": "snake-kiss-cut-stickers-358",
    "name": "SNAKE KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "jellyfish",
    "file": "jellyfish.png",
    "slug": "jellyfish-kiss-cut-stickers-358",
    "name": "JELLYFISH KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "puffer",
    "file": "puffer.png",
    "slug": "puffer-kiss-cut-stickers-358",
    "name": "PUFFER KISS-CUT STICKERS",
    "productId": 358,
    "productName": "Kiss-Cut Stickers",
    "variantId": 10163,
    "color": "White",
    "size": "3″×3″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  },
  {
    "mascot": "scorpion",
    "file": "scorpion-main.png",
    "slug": "scorpion-kiss-cut-sticker-sheet-505",
    "name": "SCORPION KISS-CUT STICKER SHEET",
    "productId": 505,
    "productName": "Kiss-Cut Sticker Sheet",
    "variantId": 12917,
    "color": "White",
    "size": "5.83″×8.27″",
    "technique": "DIGITAL",
    "placement": "default",
    "view": "print-surface",
    "layout": "center",
    "productType": "object",
    "catalogGroup": "HOME",
    "collection": "EXPANSION 001",
    "catalogCheckedAt": "2026-09-22T04:27:28.391Z",
    "publication": "official-mockup-required"
  }
];
